import { type Operation, type ScheduledTransferType } from 'investments/common/entities'

export enum InvestmentsScheduledTransferKeyEnum {
  AUTOMATIC = 'automatic_deposit',
  ONE_SHOT = 'one_shot_deposit',
  RECURRENT = 'recurrent_deposit'
}

export enum InvestmentsOperationKey {
  CARD_PAYMENTS = 'card_payments',
  TRANSFERS = 'transfers',
  BARCODE_PAYMENTS = 'barcode_payments'
}

export enum AccrualPeriodicityEnum {
  DAILY = 'daily',
  MONTHLY = 'monthly'
}

export const getAccrualPeriodicityLabel: Record<`${AccrualPeriodicityEnum}`, string> = {
  [AccrualPeriodicityEnum.DAILY]: 'Diário',
  [AccrualPeriodicityEnum.MONTHLY]: 'Mensal'
}

export const getOperationsVariants: Record<Operation, string> = {
  card_payments: 'Maquininhas',
  transfers: 'PIX e outras transferências',
  barcode_payments: 'Boletos'
}

export const isAutomaticScheduledTransferKey = (type: ScheduledTransferType) =>
  type === InvestmentsScheduledTransferKeyEnum.AUTOMATIC
export const isOneShotScheduledTransferKey = (type: ScheduledTransferType) =>
  type === InvestmentsScheduledTransferKeyEnum.ONE_SHOT
export const isRecurrentScheduledTransferKey = (type: ScheduledTransferType) =>
  type === InvestmentsScheduledTransferKeyEnum.RECURRENT
